import AccessTime from '@mui/icons-material/AccessTime';
import ArrowBackIosNew from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { buttonClasses } from '@mui/material/Button';
import { Theme } from '@mui/material/styles';

const dateList = [
  'DatePicker',
  'DateTimePicker',
  'StaticDatePicker',
  'DesktopDatePicker',
  'DesktopDateTimePicker',
  //
  'MobileDatePicker',
  'MobileDateTimePicker',
];

const timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];

const switchIcon = () => <ExpandMore />;
const leftIcon = () => <ArrowBackIosNew />;
const rightIcon = () => <ArrowForwardIos />;
const calendarIcon = () => <CalendarMonth />;
const clockIcon = () => <AccessTime />;

const desktopTypes = Object.fromEntries(
  dateList.map((name) => [
    `Mui${name}`,
    {
      defaultProps: {
        slots: {
          openPickerIcon: calendarIcon,
          leftArrowIcon: leftIcon,
          rightArrowIcon: rightIcon,
          switchViewIcon: switchIcon,
        },
      },
    },
  ]),
);

const timeTypes = Object.fromEntries(
  timeList.map((name) => [
    `Mui${name}`,
    {
      defaultProps: {
        slots: {
          openPickerIcon: clockIcon,
          rightArrowIcon: rightIcon,
          switchViewIcon: switchIcon,
        },
      },
    },
  ]),
);

export function datePicker(theme: Theme) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          '& .MuiPickersLayout-actionBar': {
            [`& .${buttonClasses.root}:last-of-type`]: {
              backgroundColor: theme.palette.text.primary,
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.common.white
                  : theme.palette.grey[800],
            },
          },
        },
      },
    },

    // Date
    ...desktopTypes,

    // Time
    ...timeTypes,
  };
}
